import { config } from "@cyberalarm/common";
import { differenceInMinutes, parse } from "date-fns";

export const getDifferenceInMinutes = (date: string) => {
  return differenceInMinutes(
    new Date(),
    parse(date, config.dateFormat, new Date()),
  );
};
